import { filterData } from "../../data/filter";
import { mostPopularData, newItemsData } from "../../data/menu";
import { ACTIVE_FILTER, FILTER_DATA, MENU_DATA, MENU_FIXED, SEARCH, SECTION_DATA } from "../types/menu";

const initialState = {
  search: "",
  filterData: null,
  activeFilter: [],
  sectionData: null,
  menuData: null,
};

const menuReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SEARCH:
      return { ...state, search: payload };
    case FILTER_DATA:
      return { ...state, filterData: payload };
    case ACTIVE_FILTER:
      return { ...state, activeFilter: payload };
    case SECTION_DATA:
      return { ...state, sectionData: payload };
    case MENU_FIXED:
      return { ...state, menuFixed: payload };
    case MENU_DATA:
      return { ...state, menuData: payload };
    default:
      return state;
  }
};

export default menuReducer;
